import { render, staticRenderFns } from "./RelationshipsAddressesNew.vue?vue&type=template&id=c55c7bc8&"
import script from "./RelationshipsAddressesNew.vue?vue&type=script&lang=js&"
export * from "./RelationshipsAddressesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports